export default __webpack_public_path__ + "static/media/groupcoachingjoin.0d2057fc.svg";